import { render, staticRenderFns } from "./ApiCorreosTab.vue?vue&type=template&id=31e6005a&scoped=true"
import script from "./ApiCorreosTab.vue?vue&type=script&lang=js"
export * from "./ApiCorreosTab.vue?vue&type=script&lang=js"
import style0 from "./ApiCorreosTab.vue?vue&type=style&index=0&id=31e6005a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e6005a",
  null
  
)

export default component.exports